import React from "react";
import { DraftsWrap } from "./styles";

const Drafts = () => {
  return <DraftsWrap>Drafts</DraftsWrap>;
};

export default Drafts;
